import React, { useEffect, useState } from 'react';

function NavbarItem({ render, href, label, icon, onClick, style  }) {
  const [hash, setHash] = useState(
    typeof window !== 'undefined' ? window.location.hash : ''
  );

  useEffect(() => {
    const handler = () => setHash(window.location.hash);
    window.addEventListener('hashchange', handler);
    return () => window.removeEventListener('hashchange', handler);
  }, []);

  if (!render) return null;

  const isActive = hash === href;

  /*transition: 0.5s;*/
  const base = 'flex items-center nav-link-sidebar px-2 py-3 text-sm md:text-base transition duration-[0.5s,1.5s] ease-in-out ';
  const inactive = 'hover:bg-[rgba(140,184,98,0.8667)] ';
  const active =
    'bg-[rgba(140,184,98,0.8667)] text-white font-semibold border-l-4 border-red-600';

    
  return (
    <li className="nav-item">
      <a href={href} onClick={onClick} style={style} className={`${base} ${isActive ? active : inactive}`}>
        {icon ? <i className={`${icon} mr-3 text-lg md:text-xl text-white-500`}></i> : null}
        <span>{label}</span>
      </a>
    </li>
  );
}

export default NavbarItem;
